import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export const useS3SyncDownload = () => {
  return useApiMutation<Blob, { path: string }>({
    mutationOptions: {
      mutationKey: ["s3-download"],
      mutationFn: async ({ path }) => {
        const response = await axiosInstance.get("/storage/s3-download", {
          responseType: "blob",
          params: {
            path,
          },
        });
        return response.data;
      },
    },
  });
};
